import { createAction } from 'redux-actions'

export const Set_User_Info = 'set user info'

export const Delete_User_Info = 'delete user info'

export const setUserInfo = createAction(Set_User_Info)
export const deleteUserInfo = createAction(Delete_User_Info)
